import React from 'react';

const NavBar = (props) => {
  const { user } = props;
  return (
    <>
      {user.id && (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <a className="navbar-brand" href="/quizshow-admin">QuizShow</a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <a className="nav-link" href="/quizshow-admin">Admin</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/quizshow-speed">Speed</a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link" href="/quizshow-admin">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">Features</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">Pricing</a>
              </li>
              <li className="nav-item">
                <a className="nav-link disabled">Disabled</a>
              </li> */}
            </ul>
            <span className="navbar-text">
              <b>{user.nickname}</b>님 환영합니다.
            </span>
          </div>
        </nav>
      )}
    </>
  );
};

export { NavBar };
